import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEllipsisV, faTrash, faUndo,faEye, faMailForward } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import './index.scss';

const MySwal = withReactContent(Swal)
const OperatorDrodown = ({ data,  className = '' ,_confirmDelete,_editOperator,_confirmRestore, _confirmResendEmail}) => {
	const history = useHistory();
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const toggle = (e) => {
			e.stopPropagation()
			setDropdownOpen(prevState => !prevState);
	}

		/**
	 * @description method call to soft delete Operator 
	 * @returns 
	 */
		 const _deleteOperator  = () => {
			MySwal.fire({
				title: 'Are you sure?',
				text: "You want to archive this User ",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, archive it!'
			}).then((result) => {
	
				if (result.isConfirmed) {
					_confirmDelete(data._id)
					MySwal.fire(
						'Archived!',
						'User has been archived.',
						'success'
					)
				}
			})	
		}

		const _resendEmail  = () => {
			MySwal.fire({
				title: 'Are you sure?',
				text: "You want to resend the Account Setup Mail this User ",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, Resend it!'
			}).then((result) => {
	
				if (result.isConfirmed) {
					_confirmResendEmail(data._id)
					MySwal.fire(
						'Archived!',
						'Account Setup Mail has been sent to User.',
						'success'
					)
				}
			})
	
		}


		/**
	 * @description method call to restore Operator 
	 * @returns 
	 */
	const _restoreOperator  = () => {
		MySwal.fire({
			title: 'Are you sure?',
			text: "You want to restore this user ",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, restore it!'
		}).then((result) => {

			if (result.isConfirmed) {
				_confirmRestore(data._id)
				MySwal.fire(
					'Restored!',
					'User has been restored.',
					'success'
				)
			}
		})

	}


	return (
		<Dropdown isOpen={dropdownOpen} toggle={toggle} className={`operator-dropdown position-absolute ${className}`}>
			<DropdownToggle color='link' className='icon-btn'>
				<FontAwesomeIcon icon={faEllipsisV} />
			</DropdownToggle>
			{!data.deleted && (<DropdownMenu>
				{/* <DropdownItem onClick={() => _editOperator(data)}> */}
				<DropdownItem onClick={() => history.push('/edit-user', {id : data._id})}>
					<span>
						<FontAwesomeIcon icon={faEdit} />
					</span>
					Edit
				</DropdownItem>
				<DropdownItem onClick={() => history.push({ pathname: "/user-detail",state: {optdata:data}})}>
					<span>
						<FontAwesomeIcon icon={faEye} />
					</span>
					View
				</DropdownItem>
				<DropdownItem onClick={() => _deleteOperator(data._id)}>
					<span>
						<FontAwesomeIcon icon={faTrash} />
					</span>
					Archive
				</DropdownItem>
				{(data.accountSetup == false) && <DropdownItem onClick={() => _resendEmail(data._id)}>
					<span>
						<FontAwesomeIcon icon={faMailForward} />
					</span>
					Resend Email
				</DropdownItem>}
			</DropdownMenu>)
			}
			{data.deleted && (<DropdownMenu>
				<DropdownItem onClick={() => history.push({ pathname: "/user-detail",state: {optdata:data}})}>
					<span>
						<FontAwesomeIcon icon={faEye} />
					</span>
					View
				</DropdownItem>
				<DropdownItem onClick={() => _restoreOperator()}>
					<span>
						<FontAwesomeIcon icon={faUndo} />
					</span>
					Restore
				</DropdownItem>
			</DropdownMenu>
			)}
		</Dropdown>
	);
}

export default OperatorDrodown;